export default __webpack_public_path__ + "static/media/Untitled-4.e29008ce.png";